/* Wristify Cart Drawer
   Reads /cart.js, renders rewards rail + line items + upsells + totals.
   Public API: window.WristifyCart.open() / .close() / .refresh() / .add(id, qty) */

(function () {
  var root = document.getElementById('wcd');
  if (!root) return;

  var cfgEl = document.getElementById('wcd-config');
  var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  cfg.milestones = cfg.milestones || [];
  cfg.upsells = cfg.upsells || [];

  var els = {
    panel: root.querySelector('.wcd__panel'),
    scrim: root.querySelector('.wcd__scrim'),
    count: root.querySelector('[data-wcd-count]'),
    rewards: root.querySelector('[data-wcd-rewards]'),
    body: root.querySelector('[data-wcd-body]'),
    upsell: root.querySelector('[data-wcd-upsell]'),
    track: root.querySelector('[data-wcd-track]'),
    foot: root.querySelector('[data-wcd-foot]')
  };

  var cart = null;
  var busy = false;
  var lastFocus = null;

  var nf = new Intl.NumberFormat(cfg.locale || 'en-US', {
    style: 'currency',
    currency: cfg.currency || 'USD'
  });
  function money(cents) { return nf.format((cents || 0) / 100); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Shopify CDN accepts a width param; leave anything else untouched
  function sized(url, w) {
    if (!/^https?:/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function isGift(item) {
    return !!(item.properties && item.properties._gift);
  }

  function setBusy(state) {
    busy = state;
    root.setAttribute('data-busy', state ? 'true' : 'false');
  }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  var ICON = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 7h11v9H2zM13 10h4l4 3v3h-8z"/><circle cx="7" cy="18.5" r="1.6"/><circle cx="17" cy="18.5" r="1.6"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h8l10 10-8 8L3 11z"/><circle cx="7.5" cy="7.5" r="1.4" fill="currentColor" stroke="none"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>',
    chevD: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>'
  };

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Subtotal that counts toward rewards (gift lines excluded)
  function eligibleTotal(c) {
    return c.items.reduce(function (sum, item) {
      return isGift(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  // Add / remove gift lines so the cart matches the unlocked milestones.
  function syncGifts(c) {
    var total = eligibleTotal(c);
    var jobs = [];

    cfg.milestones.forEach(function (m) {
      if (!m.giftVariantId) return;
      var line = null;
      c.items.forEach(function (item) {
        if (item.variant_id === m.giftVariantId && isGift(item)) line = item;
      });

      if (total >= m.threshold && !line) {
        jobs.push(post('/cart/add.js', {
          items: [{ id: m.giftVariantId, quantity: 1, properties: { _gift: 'true' } }]
        }));
      } else if (total < m.threshold && line) {
        jobs.push(post('/cart/change.js', { id: line.key, quantity: 0 }));
      }
    });

    if (!jobs.length) return Promise.resolve(false);
    return Promise.all(jobs).then(function () { return true; });
  }

  function refresh(skipGiftSync) {
    setBusy(true);
    return getCart()
      .then(function (c) {
        if (skipGiftSync) return c;
        return syncGifts(c).then(function (changed) {
          return changed ? getCart() : c;
        });
      })
      .then(function (c) {
        cart = c;
        render();
        setBusy(false);
        document.dispatchEvent(new CustomEvent('wristify:cart:updated', { detail: c }));
        return c;
      })
      .catch(function (err) {
        console.error('[Wristify cart]', err);
        setBusy(false);
      });
  }

  function render() {
    if (!cart) return;
    els.count.textContent = cart.item_count;
    renderRewards();
    renderItems();
    renderUpsells();
    renderFoot();
  }

  function renderRewards() {
    var ms = cfg.milestones;
    if (!ms.length || !cart.item_count) { els.rewards.hidden = true; return; }
    els.rewards.hidden = false;

    var total = eligibleTotal(cart);
    var n = ms.length;

    // Nodes sit at even intervals so labels never collide, whatever the
    // thresholds are. The fill interpolates piecewise between them.
    function nodePct(i) { return ((i + 1) / n) * 100; }

    function fillPct() {
      for (var i = 0; i < n; i++) {
        var lo = i === 0 ? 0 : ms[i - 1].threshold;
        var hi = ms[i].threshold;
        if (total < hi) {
          var loPos = (i / n) * 100;
          return loPos + ((total - lo) / (hi - lo)) * (nodePct(i) - loPos);
        }
      }
      return 100;
    }

    var next = null;
    for (var j = 0; j < n; j++) {
      if (total < ms[j].threshold) { next = ms[j]; break; }
    }

    var msg = next
      ? '<strong>' + money(next.threshold - total) + '</strong> away from ' + esc(next.reward)
      : 'All rewards unlocked!';

    var nodes = ms.map(function (m, i) {
      var unlocked = total >= m.threshold;
      return (
        '<div class="wcd__node" style="left:' + nodePct(i) + '%" data-unlocked="' + unlocked + '">' +
          '<span class="wcd__node-dot">' + (m.icon === 'truck' ? ICON.truck : ICON.tag) + '</span>' +
          '<span class="wcd__node-label"><b>' + money(m.threshold) + '</b>' + esc(m.label) + '</span>' +
        '</div>'
      );
    }).join('');

    // Everything the fill needs is inline, and it carries a child element, so
    // no theme rule (display:none, :empty, height resets) can suppress it.
    els.rewards.innerHTML =
      '<p class="wcd__rewards-msg">' + msg + '</p>' +
      '<div class="wcd__rail"><div class="wcd__rail-fill" style="display:block!important;position:absolute;top:0;left:0;height:100%;border-radius:6px;width:' + fillPct() + '%;background:linear-gradient(90deg,#ff8f4d 0%,#ff6a13 100%);"><span style="display:block;width:1px;height:100%;"></span></div>' + nodes + '</div>';
  }

  function renderItems() {
    if (!cart.item_count) {
      els.body.innerHTML =
        '<div class="wcd__empty">' +
          '<h3>Your cart is empty</h3>' +
          '<p>Straps built to outlast the watch.</p>' +
          '<a href="' + esc(cfg.continueUrl || '/collections/all') + '">Shop straps</a>' +
        '</div>';
      return;
    }

    els.body.innerHTML = cart.items.map(function (item) {
      var gift = isGift(item);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var free = item.final_line_price === 0;

      var price = free
        ? '<s>' + money(item.original_line_price) + '</s><em>FREE</em>'
        : item.original_line_price > item.final_line_price
          ? '<s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price)
          : money(item.final_line_price);

      return (
        '<div class="wcd__item" data-key="' + esc(item.key) + '">' +
          '<div class="wcd__item-media">' +
            (item.image ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<a class="wcd__item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            (gift ? '<span class="wcd__badge">' + ICON.tag + 'Free gift</span>' : '') +
            (variant ? '<p class="wcd__item-variant">' + esc(variant) + '</p>' : '') +
            (gift ? '' :
              '<div class="wcd__stepper">' +
                '<button type="button" data-wcd-step="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-wcd-step="1" aria-label="Increase quantity">+</button>' +
              '</div>') +
          '</div>' +
          '<div class="wcd__item-right">' +
            '<button type="button" class="wcd__remove" data-wcd-remove aria-label="Remove ' + esc(item.product_title) + '">' + ICON.trash + '</button>' +
            '<div class="wcd__price">' + price + '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderUpsells() {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });

    var list = cfg.upsells.filter(function (p) { return !inCart[p.id]; });
    if (!list.length || !cart.item_count) { els.upsell.hidden = true; return; }
    els.upsell.hidden = false;

    els.track.innerHTML = list.map(function (p) {
      var first = p.variants[0] || { price: 0 };
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '"' +
          ' data-image="' + esc(v.image || p.image || '') + '"' +
          (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>';
      }).join('');

      return (
        '<div class="wcd__card" data-product="' + p.id + '">' +
          '<img src="' + esc(first.image || p.image || '') + '" alt="" loading="lazy">' +
          '<div>' +
            '<h4>' + esc(p.title) + '</h4>' +
            '<div class="wcd__card-row">' +
              (p.variants.length > 1
                ? '<select data-wcd-variant aria-label="Choose an option">' + opts + '</select>'
                : '<input type="hidden" data-wcd-variant value="' + first.id + '">') +
              '<button type="button" class="wcd__add" data-wcd-add>+ Add</button>' +
            '</div>' +
            '<p class="wcd__card-price" data-wcd-cardprice>' + money(first.price) + '</p>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderFoot() {
    if (!cart.item_count) { els.foot.innerHTML = ''; return; }

    var saved = cart.original_total_price - cart.total_price;

    els.foot.innerHTML =
      '<button type="button" class="wcd__disc-toggle" data-wcd-disc-toggle aria-expanded="false">Discount code' + ICON.chevD + '</button>' +
      '<div class="wcd__disc-form" data-wcd-disc-form>' +
        '<input type="text" placeholder="Enter code" data-wcd-disc-input autocomplete="off" spellcheck="false">' +
        '<button type="button" data-wcd-disc-apply>Apply</button>' +
      '</div>' +
      (saved > 0 ? '<div class="wcd__row wcd__row--discount"><span>Discount</span><span>&minus;' + money(saved) + '</span></div>' : '') +
      '<div class="wcd__row wcd__row--total"><span>Subtotal</span><span>' +
        (saved > 0 ? '<s>' + money(cart.original_total_price) + '</s>' : '') + money(cart.total_price) +
      '</span></div>' +
      '<button type="button" class="wcd__checkout" data-wcd-checkout>' + ICON.lock + 'Checkout &bull; ' + money(cart.total_price) + '</button>' +
      (cfg.paymentIcons ? '<div class="wcd__pay">' + cfg.paymentIcons + '</div>' : '') +
      '<p class="wcd__note">Taxes and shipping calculated at checkout.</p>';
  }

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    refresh().then(function () {
      var btn = root.querySelector('.wcd__close');
      if (btn) btn.focus();
    });
  }

  function close() {
    root.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (busy) return;

    if (e.target.closest('.wcd__scrim') || e.target.closest('.wcd__close')) { close(); return; }

    var step = e.target.closest('[data-wcd-step]');
    if (step) {
      var key = step.closest('.wcd__item').dataset.key;
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      setBusy(true);
      post('/cart/change.js', { id: key, quantity: item.quantity + Number(step.dataset.wcdStep) })
        .then(function () { refresh(); });
      return;
    }

    var rm = e.target.closest('[data-wcd-remove]');
    if (rm) {
      setBusy(true);
      post('/cart/change.js', { id: rm.closest('.wcd__item').dataset.key, quantity: 0 })
        .then(function () { refresh(); });
      return;
    }

    var add = e.target.closest('[data-wcd-add]');
    if (add) {
      var card = add.closest('.wcd__card');
      var id = card.querySelector('[data-wcd-variant]').value;
      add.disabled = true;
      add.textContent = 'Added';
      post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
        .then(function () { refresh(); });
      return;
    }

    var arrow = e.target.closest('[data-wcd-scroll]');
    if (arrow) {
      els.track.scrollBy({ left: Number(arrow.dataset.wcdScroll) * els.track.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }

    var dt = e.target.closest('[data-wcd-disc-toggle]');
    if (dt) {
      var form = root.querySelector('[data-wcd-disc-form]');
      var openNow = form.dataset.open !== 'true';
      form.dataset.open = openNow;
      dt.setAttribute('aria-expanded', openNow);
      if (openNow) form.querySelector('input').focus();
      return;
    }

    if (e.target.closest('[data-wcd-disc-apply]')) { applyDiscount(); return; }

    if (e.target.closest('[data-wcd-checkout]')) { window.location.href = '/checkout'; }
  });

  // Changing an upsell variant swaps both its price and its image
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-wcd-variant]');
    if (!sel || sel.tagName !== 'SELECT') return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.wcd__card');
    card.querySelector('[data-wcd-cardprice]').textContent = money(Number(opt.dataset.price));
    var img = card.querySelector('img');
    if (img && opt.dataset.image) img.src = opt.dataset.image;
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-wcd-disc-input]')) {
      e.preventDefault();
      applyDiscount();
    }
  });

  function applyDiscount() {
    var input = root.querySelector('[data-wcd-disc-input]');
    var code = (input.value || '').trim();
    if (!code) return;
    setBusy(true);
    // Sets the discount cookie so it carries into checkout, then reflects it in the cart.
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
      .then(function () { return post('/cart/update.js', { discount: code }); })
      .then(function () { return refresh(true); })
      .then(function () {
        if (cart && cart.original_total_price <= cart.total_price) {
          var box = root.querySelector('[data-wcd-disc-input]');
          if (box) { box.value = ''; box.placeholder = 'Code not valid'; }
        }
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
  });

  // Open the drawer instead of navigating to /cart
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-wcd-open]');
    if (!link) return;
    e.preventDefault();
    open();
  });

  // Intercept add-to-cart forms so products land in this drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-wcd-ignore')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        open();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.submit();
      });
  });

  window.WristifyCart = {
    open: open,
    close: close,
    refresh: refresh,
    add: function (variantId, qty) {
      return post('/cart/add.js', { items: [{ id: Number(variantId), quantity: qty || 1 }] })
        .then(function () { open(); });
    }
  };

  // Warm the cart state so the count bubble is right on load
  refresh(true);
})();
